import React from 'react'
import PropTypes from 'prop-types'
import { useHistory } from 'react-router-dom'
import moment from 'moment'

const ListItem = ({ salesEvent }) => {
  const { name, startTime, salesEventTypeName, locked } = salesEvent
  const history = useHistory()

  const onClickSalesEvent = () =>
    history.push({ state: { salesEventUuid: salesEvent.uuid } })

  return (
    <div className="item">
      <div className="row" onClick={onClickSalesEvent} role="button">
        <div className="item-info-wrapper -bold">{name}</div>
        <div className="item-info-wrapper">{salesEventTypeName}</div>
        <div className="item-info-wrapper">
          {moment(startTime).format('M/DD/YYYY h:mm A')}
        </div>
        <div className="item-info-wrapper">
          <div className="item-type">
            {locked ? (
              <>
                <span className="item-type__dot -off"></span>
                <p>Inactive</p>
              </>
            ) : (
              <>
                <span className="item-type__dot -on"></span>
                <p>Active</p>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

ListItem.propTypes = {
  salesEvent: PropTypes.object,
}

export default ListItem
